import React from 'react'

import { Button } from '../buttons'
import { Spacer } from '../global'
import { SectionSubtitle } from '../texts'

type ErrorScreenProps = {
  title?: string
  message?: string
  onRetry?: () => void
}

const ErrorScreen: React.FC<ErrorScreenProps> = ({
  title = 'Algo salió mal',
  message = 'No pudimos cargar la información. Intenta nuevamente.',
  onRetry,
}) => {
  const handleRetry = () => {
    if (onRetry) onRetry()
    else window.location.reload()
  }

  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px',
        textAlign: 'center',
      }}
    >
      <SectionSubtitle fontSize={20} fontWeight={600} lineHeight={24}>
        {title}
      </SectionSubtitle>
      <Spacer height={12} />
      <p style={{ maxWidth: 360 }}>{message}</p>
      <Spacer height={24} />
      <Button onClick={handleRetry} label="Reintentar" className="dark-grey" />
    </div>
  )
}

export default ErrorScreen
